import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { IModelInfo } from "../../entities/nu-model-info";
import { IMultiSelectItem } from "../../infrastructure/multi-select-item";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";

@Component
export default class ModelScenarioChooser extends Vue {

    @Prop()
    value: IModelInfo;

//    @Prop()
    scenarioNamesSelection: Array<IMultiSelectItem> = [];
    
//    @Prop()
    selectedScenarioNames: Array<string> = [];

    private modelObserver = new ModelNotifier();
    private modelServices = new modelServices(this.modelObserver);


    @Watch("value")
    valueChanged(newVal: IModelInfo) {
        if (newVal)
            this.refreshScenarioNamesSelection(newVal.fullyQualifiedModelId);
    }

    refreshScenarioNamesSelection(modelId: string) {
        if (modelId)
            this.modelServices.getScenarioNames(modelId)
                .then(value => {
                    this.scenarioNamesSelection = value.map(item => ({
                        label: item.name, value: item.name
                    }));
                    this.selectedScenarioNames = [];
                });

    }

    mounted() {
        if (this.value)
        this.refreshScenarioNamesSelection(this.value.fullyQualifiedModelId);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/model-scenario-chooser/model-scenario-chooser.ts